import React, { memo, ReactNode } from 'react';
import cn from 'classnames';
import { Spinner, IconButton } from 'components';

import { ButtonV3 } from 'components/ComponentV2';
import styles from './Confirmation.module.scss';

export interface ConfirmationProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  isLoading?: boolean;
  style?: Record<string, unknown>;
  title: string;
  desc: ReactNode;
  buttonContent: string;
  onCancel: () => void;
  onConfirm: () => void;
  isPrimary?: boolean;
  secondaryActionOnRight?: boolean;
  hideSecondaryAction?: boolean;
}

export const Confirmation: React.FC<ConfirmationProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    title,
    desc,
    isLoading,
    buttonContent,
    onCancel,
    onConfirm,
    isPrimary,
    secondaryActionOnRight = false,
    hideSecondaryAction = false,
  }: ConfirmationProps) => {
    const confirmationBoxClasses = cn(
      {
        [styles.Confirmation]: true,
      },
      className
    );

    return (
      <div className={confirmationBoxClasses} style={style}>
        <div className={styles.ConfirmationHeader}>
          <p>{title}</p>
          <IconButton
            className={styles.closeIcon}
            size="small"
            iconName="close"
            onClick={onCancel}
          />
        </div>
        <div className={styles.ConfirmationContent}>{desc}</div>
        <div
          className={cn(styles.ConfirmationFooter, {
            [styles.secondaryActionOnRight]: secondaryActionOnRight,
          })}
        >
          {!hideSecondaryAction && (
            <ButtonV3
              color={secondaryActionOnRight ? 'secondary' : 'black'}
              onClick={onCancel}
              borderRadius={10}
              className={styles.secondaryAction}
            >
              Cancel
            </ButtonV3>
          )}
          <ButtonV3
            className={cn(styles.primaryAction, {
              [styles.primaryActionGreen]: isPrimary,
            })}
            borderRadius={10}
            onClick={onConfirm}
          >
            {isLoading ? (
              <Spinner className={styles.Loader} color="secondary" />
            ) : (
              buttonContent
            )}
          </ButtonV3>
        </div>
      </div>
    );
  }
);

Confirmation.displayName = 'Confirmation';
